const flatCustomFields = customFields => {
    if (!Array.isArray(customFields)) {
        return []
    }

    return customFields.reduce((t, c) => {
        return t.concat(c.fields)
    }, [])
}

// 获取需要触发自动搜索的表单项
export const getTriggerOnChangeFields = ({ fields, customFields }) => {
    return fields
        .concat(flatCustomFields(customFields))
        .filter(v => v.triggerSearchOnChange)
        .map(v => `${v.name}`)
}
// 触发搜索后是否需要清空其他查询项（默认清空）
export const getTriggerSearchOnChangeNoClearFields = ({ fields, customFields }) => {
    return fields
        .concat(flatCustomFields(customFields))
        .filter(v => v.triggerSearchOnChange)
        .filter(v => v.triggerSearchOnChangeNoClear)
        .map(v => `${v.name}`)
}

// 检测是否触发搜索, 搜索后其他查询项不要清空
export default ({ fields, customFields, changedValues }) => {
    const triggerArr = getTriggerOnChangeFields({ fields, customFields })
    const triggerNoClearArr = getTriggerSearchOnChangeNoClearFields({ fields, customFields })

    return [
        Object.keys(changedValues || {}).some(v => triggerArr.includes(v)),
        Object.keys(changedValues || {}).some(v => triggerNoClearArr.includes(v))
    ]
}

export const getFlatFields = ({ fields, customFields }) => {
    return fields.concat(flatCustomFields(customFields)).map(v => v.name)
}

export const getFlatFieldsMap = ({ fields, customFields }) => {
    return fields.concat(flatCustomFields(customFields)).reduce((t, c) => {
        t[c.name] = c

        return t
    }, {})
}
